import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'connectionDuration'
})
export class ConnectionDurationPipe implements PipeTransform {
  transform(startDate: Date, currentTime?: Date): string {
    const now = currentTime || new Date();
    const diffMs = now.getTime() - new Date(startDate).getTime();
    const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
    const hours = Math.floor(diffMs / (1000 * 60 * 60));

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    } else if (minutes > 0) {
      return `${minutes}m `;
    }
    return `less than 1 minute`;
  }
}
